<template>
  <div>
    <Header/>
    <section class="module_top">
      <div class="container">
        <div class="module_top_content">
          <h2>模块化信用产品与服务</h2>
          <p>与已有业务流程完美融合 全流程信用管理在您身边</p>
          <button @click="showContact('模块化信用产品与服务',12)">一键获取产品</button>
        </div>
      </div>
    </section>

    <section class="nav_box container flex flex_between" :class="{fixed:fixed}">
      <section class="module_left">
        <ul class="module_left_menu">
          <li
            :class="['left_menu_item',leftActive==item.id?'active':'']"
            v-for="item in leftMenu"
            @click="changeLeftMenu(item,0)"
          >
            <p><span class="iconfont" v-html="item.icon"></span>{{ item.text }}</p>
          </li>
        </ul>
      </section>
      <section class="module_right">
        <section style="overflow: hidden;">
          <div class="module_right_top flex flex_center flex_between">
            <ul class="module_right_menu flex flex_center flex_between">
              <li
                :class="['right_menu_item',rightActive===item.id?'active':'']"
                v-for="item in rightMenu"
              >
                <a @click="goScroll(item.id)">{{ item.text }}</a>
              </li>
            </ul>
            <button class="module_right_btn" @click="showContact(leftText,leftActive)">获取该产品</button>
          </div>
        </section>
      </section>
    </section>

    <section class="right_content container flex" :class="{fixed:fixed}" style="z-index: 10">
      <div class="module_right">
        <section class="sanwei flex flex_between" id="right0">
          <div class="sanwei_content">
            <h3 class="flex flex_center">
              <span class="iconfont"
                    v-if="moduleData.data[leftActive-7].sanweiData.icon"
                    v-html="moduleData.data[leftActive-7].sanweiData.icon"></span>
              {{ moduleData.data[leftActive-7].sanweiData.title }}
            </h3>
            <p>{{ moduleData.data[leftActive-7].sanweiData.text }}</p>
          </div>
          <img :src="require(`../../assets/module/module${leftActive}.png`)" alt="">
        </section>

        <section id="right1">
          <h2 class="module_title">核心功能</h2>
          <ul class="core_module flex flex_between flex_wrap">
            <li v-for="item in moduleData.data[leftActive-7].coreData">
              <h5>{{ item.title }}</h5>
              <p>{{ item.text }}</p>
            </li>
          </ul>
        </section>

        <section id="right2">
          <h2 class="module_title">应用场景</h2>
          <ul class="scene_module flex flex_wrap">
            <li v-for="(item,index) in moduleData.data[leftActive-7].sceneData">
              <img :src="require(`../../assets/module/changjing${index}.jpg`)" alt="">
              <h5 class="flex flex_column flex_center" v-html="item.title"></h5>
              <p class="flex flex_center">{{ item.text }}</p>
            </li>
          </ul>
        </section>

        <section id="right3">
          <h2 class="module_title">产品优势</h2>
          <ul class="advantage_module flex flex_wrap">
            <li v-for="item in moduleData.data[leftActive-7].advantage">
              <h5>
                <span v-if="item.icon" class="iconfont" v-html="item.icon"></span>
                <img v-else src="../../assets/module/mokuaihua.png" alt="">
                {{ item.title }}
              </h5>
              <p>{{ item.text }}</p>
            </li>
          </ul>
        </section>

        <section class="case_moudle" :class="`case_moudle${leftActive}`" id="right4">
          <h2 class="module_title">客户案例</h2>
          <div>
            <h4 v-html="moduleData.data[leftActive-7].case.title"></h4>
            <p>{{ moduleData.data[leftActive-7].case.text }}</p>
          </div>
        </section>
      </div>
    </section>
    <UserNeed ref="userNeed"/>
  </div>
</template>

<script>
import Header from "@/components/Header";
import UserNeed from "@/components/UserNeed";
import { data } from "./data"

export default {
  name: "ModuleProducts",
  components: {
    Header, UserNeed
  },
  data() {
    return {
      leftActive: 7,
      leftText: '三维信用诊断系统',
      rightActive: 0,
      leftMenu: data.leftMenu,
      rightMenu: data.rightMenu,
      moduleData: data,
      fixed: false
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.changeLeftMenu(this.$route.query)
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  watch: {
    '$route.query': function (val) {
     this.changeLeftMenu(val);
    }
  },
  methods: {
    handleScroll() {
      //获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop >= 510) {
        this.fixed = true;
      } else {
        this.fixed = false;
      }
      if (scrollTop < 864) {
        this.rightActive = 0;
      } else if (scrollTop >= 864 && scrollTop < 1150) {
        this.rightActive = 1;
      } else if (scrollTop >= 1150 && scrollTop < 1550) {
        this.rightActive = 2;
      } else if (scrollTop >= 1550 && scrollTop < 1900) {
        this.rightActive = 3;
      } else if (scrollTop >= 1900) {
        this.rightActive = 4;
      }
    },
    changeLeftMenu(item,type) {
      console.log(777)
      if(type==0){
        window.scroll({
          top: 510,
          behavior: 'smooth'
        })
      }else{
        window.scroll({
          top: 0,
          behavior: 'smooth'
        })
      }
      this.leftActive =item.id;
      this.leftText = item.text;
    },
    showContact(title, id) {
      this.$refs.userNeed.showModal(title, id);
    },
    goScroll(id) {
      console.log('99999')
      this.rightActive = id;
      if (id == 0) {
        window.scroll({
          top: 510,
          behavior: 'smooth'
        })
      } else if (id == 1) {
        window.scroll({
          top: this.leftActive==9?840:864,
          behavior: 'smooth'
        })
      } else if (id == 2) {
        window.scroll({
          top: this.leftActive==9?1340:1150,
          behavior: 'smooth'
        })
      } else if (id == 3) {
        let top=1550;
        if(this.leftActive==8){
          top=1620;
        }else if(this.leftActive==9){
          top=1740;
        }
        window.scroll({
          top: top,
          behavior: 'smooth'
        })
      } else if (id == 4) {
        let top=1940;
        if(this.leftActive==8){
          top=2000
        }else if(this.leftActive==9){
          top=2100
        }else if(this.leftActive==10){
          top=1780
        }else{
          top=1940
        }
        window.scroll({
          top: top,
          behavior: 'smooth'
        })
      }
    },
  }
};
</script>

<style scoped lang="less">
  .module_top {
    background: url("../../assets/module/module_top.jpg") 0 center no-repeat;
    background-size: cover;

    .module_top_content {
      padding: 115px 0;

      h2 {
        font-size: 44px;
        color: #005293;
      }

      p {
        font-size: 20px;
        margin: 20px 0 60px;
      }

      button {
        width: 188px;
        height: 50px;
        background: linear-gradient(52deg, #005293, #1A7AC5);
        text-align: center;
        line-height: 50px;
        font-size: 22px;
        color: #fff;

        &:hover {
          background: linear-gradient(52deg, rgba(0, 82, 147, .9), rgba(26, 122, 197, .9));
        }
      }
    }
  }

  .nav_box {
    position: relative;
    z-index: 10;

    &.fixed {
      position: fixed;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }

  .module_left {
    width: 230px;
    background: #fff;

    .module_left_menu {
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      padding: 5px 0;

      .left_menu_item {
        font-size: 18px;
        padding: 20px 0;
        transition: all ease .2s;
        cursor: pointer;

        p {
          padding-left: 25px;
          height: 20px;
          border-left: 2px solid #fff;
          line-height: 20px;
        }

        .iconfont {
          color: #B2B2B2;
          font-size: 22px;
          margin-right: 10px;
          transition: all ease .2s;
        }

        &:hover, &.active {
          color: #005293;
          font-weight: 500;

          p {
            position: relative;
            border-left: 2px solid #005293;
          }

          .iconfont {
            color: #005293;
          }
        }
      }
    }
  }

  .right_content {
    margin-top: -280px;
    justify-content: flex-end;

    &.fixed {
      margin-top: 40px;
    }
  }

  .module_right {
    width: calc(100% - 290px);

    .module_right_top {
      height: 60px;
      background: #fff;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .13);
      padding: 0 10px;
      margin-bottom: 10px;

      .module_right_menu {
        width: calc(100% - 300px);
        font-size: 16px;

        a {
          display: inline-block;
          line-height: 60px;
        }

        .right_menu_item.active {
          a {
            color: #005293;
            border-bottom: 2px solid #005293;
          }
        }
      }

      .module_right_btn {
        width: 94px;
        height: 34px;
        background: linear-gradient(45deg, rgba(174,74,255,1), rgba(92,119,255,1));
        text-align: center;
        line-height: 34px;
        color: #fff;
        font-size: 14px;
        transition: all ease .3s;
        &:hover{
          background: linear-gradient(45deg, rgba(92,119,255,1), rgba(92,119,255,1));
        }
      }
    }

    .sanwei {
      background: #F4F8FF;
      padding: 35px 55px;
      margin-top: 55px;
      align-items: flex-end;

      img {
        width: 170px;
        flex:0 0 170px;
      }

      .sanwei_content {
        flex: 1;
        margin-right: 50px;
        h3 {
          font-size: 32px;
          margin-bottom: 20px;
          font-weight: 500;

          .iconfont {
            display: inline-block;
            width: 35px;
            height: 35px;
            border-radius: 50%;
            color: #fff;
            font-size: 18px;
            text-align: center;
            line-height: 35px;
            background: #005293;
            margin-right: 10px;
          }
        }

        p {
          font-size: 16px;
          color: #546896;
          text-align: justify;
          line-height: 1.8;
        }
      }
    }

    .module_title {
      font-size: 24px;
      margin: 60px 0 25px;
      font-weight: 500;
    }

    .core_module {
      li {
        width: calc(33.33% - 12px);
        box-sizing: border-box;

        &:nth-child(4), &:nth-child(5), &:nth-child(6) {
          margin-top: 20px;
        }

        h5 {
          position: relative;
          width: calc(100% - 50px);
          margin: auto;
          height: 42px;
          background: #FFA521;
          text-align: center;
          line-height: 42px;
          color: #fff;
          font-size: 18px;
          font-weight: 500;
        }

        p {
          background: #F4F8FF;
          font-size: 16px;
          text-align: justify;
          padding: 32px 25px 30px;
          margin-top: -17px;
          line-height: 1.6;
          letter-spacing: -1px;
        }
      }
    }

    .scene_module {
      justify-content: space-between;

      li {
        position: relative;
        width: calc(50% - 25px);
        box-sizing: border-box;
        margin-bottom: 30px;

        img {
          position: absolute;
          width: calc(100% - 10px);
          height: calc(100% - 10px);
          bottom: 0;
          right: 0;
          z-index: -1;
        }

        h5 {
          position: relative;
          width: 74px;
          height: 74px;
          background: linear-gradient(45deg, #005293, #5099E4);
          box-shadow: 6px 6px 3px 0px rgba(38, 120, 203, 0.33);
          font-size: 22px;
          color: #fff;
          text-indent: 3px;
          box-sizing: border-box;
          line-height: 1.2;
          font-weight: 500;
          justify-content: center;
        }

        p {
          min-height: 96px;
          padding: 0 40px 0 100px;
          font-size: 16px;
          margin-top: -64px;
          text-align: justify;
        }
      }
    }

    .advantage_module {
      width: calc(100% + 44px);
      margin-left: -22px;

      li {
        width: 33.33%;
        padding: 0 22px;
        box-sizing: border-box;

        h5 {
          vertical-align: bottom;
          font-size: 18px;
          font-weight: 500;

          .iconfont {
            font-size: 36px;
            color: #FFB000;
            margin-right: 10px;
            font-weight: normal;
          }

          img {
            width: 36px;
            margin-right: 10px;
          }
        }

        p {
          margin: 20px 0 50px;
          font-size: 16px;
          text-align: justify;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }
      }
    }
  }

  .case_moudle {
    margin: -50px 0 50px;

    div {
      background: url("../../assets/module/case_bg7.jpg") center 0 no-repeat;
      background-size: cover;
      padding: 50px 62px;
      color: #fff;

      h4 {
        font-size: 24px;
        margin-bottom: 40px;
        font-weight: 500;
      }

      p {
        font-size: 16px;
        line-height: 2;
      }
    }

    &.case_moudle7 {
      div {
        background: url("../../assets/module/case_bg7.jpg") center 0 no-repeat;
        background-size: cover;
      }
    }

    &.case_moudle8 {
      div {
        background: url("../../assets/module/case_bg8.jpg") center 0 no-repeat;
        background-size: cover;
      }
    }

    &.case_moudle9 {
      div {
        background: url("../../assets/module/case_bg9.jpg") center 0 no-repeat;
        background-size: cover;
      }
    }

    &.case_moudle10 {
      div {
        background: url("../../assets/module/case_bg10.jpg") center 0 no-repeat;
        background-size: cover;
      }
    }

    &.case_moudle11 {
      div {
        background: url("../../assets/module/case_bg11.jpg") center 0 no-repeat;
        background-size: cover;
      }
    }

  }
</style>
